import React, { Component } from 'react';
import { array, bool, func } from 'prop-types';
import { connect } from 'react-redux';

import ContainerBox from '../components/common/ContainerBox';
import Title from '../components/common/Title';
import Spinner from '../components/common/Spinner';
import ReportsList from '../components/report/ReportsList';
import { getReports } from '../actions/reportActions';

class ReportsPage extends Component {
  componentWillMount() {
    const { getReports } = this.props;
    getReports();
  }

  render() {
    const { loading, reports } = this.props;

    return (
      <ContainerBox>
        <Title margin="2rem 0 3rem 0">REPORTES</Title>
        {loading ? <Spinner /> : <ReportsList reports={reports} />}
      </ContainerBox>
    );
  }
}

ReportsPage.propTypes = {
  reports: array.isRequired,
  loading: bool.isRequired,
  getReports: func.isRequired
};

const mapState = state => ({
  reports: state.getIn(['report', 'reports']).toJS(),
  loading: state.getIn(['report', 'loading'])
});

const mapDispatch = dispatch => ({
  getReports: () => dispatch(getReports())
});

export default connect(mapState, mapDispatch)(ReportsPage);



// WEBPACK FOOTER //
// ./src/containers/ReportsPage.js